import {
    GET_EMPLOEE_CTC_REQUEST,
    GET_EMPLOEE_CTC_SUCCESS,
    GET_EMPLOEE_CTC_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getEmployeeCtcReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMPLOEE_CTC_REQUEST:
            return {
                error: "",
                loading: true,
                data: [],
            };

        case GET_EMPLOEE_CTC_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_EMPLOEE_CTC_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}

export default getEmployeeCtcReducer;
